import CreateAccountToast from 'components/CreateAccountToast';
import ExploreTournamentsComponent from 'components/Explore/Tournaments/ExploreTournaments';
import { TournamentsProps } from 'components/Explore/Tournaments/props';
import GeoLocationInitializer from 'components/utilities/GeoLocationInitializer';
import Head from 'components/utilities/Head';
import PopppinsFont from 'components/utilities/PoppinsFont';

const title = 'Pickleball Tournaments';
const description = 'Discover upcoming pickleball tournaments, competitions, and events near you.';

export default function ExploreTournaments({ tournaments }: TournamentsProps) {
  return (
    <GeoLocationInitializer>
      <Head title={title} description={description} />
      <PopppinsFont />
      <div className="fixed -left-40 -top-40 -z-100">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <ExploreTournamentsComponent tournaments={tournaments} />
      <CreateAccountToast />
    </GeoLocationInitializer>
  );
}
